import { put, takeLatest, retry } from 'redux-saga/effects';
import { PayloadAction } from 'redux-starter-kit';
import { saveAs } from 'file-saver';
import {
  Mutations,
  ResolverResponse,
  Resources,
  Requests,
} from '@erecruit/types';
import {
  getResourceApi,
  PositionSearchRequestWithDataPref,
  PositionSearchCountRequestWithDataPref,
} from '@erecruit/modules';

import {
  searchPositionsSuccess,
  searchPositionsFail,
  exportPositionsSuccess,
  exportPositionsFail,
} from './reducer';
import { RETRY_DELAY_LENGTH, RETRY_MAX_TRIES } from '../../../constants';

function* searchPositions({
  payload,
}: PayloadAction<Resources.PositionSearchParams>) {
  try {
    const responses = yield getResourceApi().getResources([
      new PositionSearchRequestWithDataPref(payload),
      new PositionSearchCountRequestWithDataPref({
        filter: payload.filter,
      }),
    ]) as Promise<ResolverResponse[]>;

    const response = responses[0] as ResolverResponse;

    if (response.success) {
      const data = responses[0].data as Resources.PositionSearch[];
      const totalCount = responses[1].data[0].value as number;
      return yield put(searchPositionsSuccess({ data, totalCount }));
    }

    yield put(searchPositionsFail(response.message));
  } catch (e) {
    console.error(e);
    yield put(searchPositionsFail(e.message));
  }
}

function* exportPositions({
  payload,
}: PayloadAction<
  Pick<Mutations.ExportPositionSearchParams, 'columns'> & {
    params: Mutations.ExportPositionSearchParams['positionSearchParams'];
  }
>) {
  try {
    const { columns, params: positionSearchParams } = payload;
    const [{ fileId }] = yield getResourceApi().createMutationRequest(
      new Requests.ExportPositionSearchRequest({
        columns,
        positionSearchParams,
      }),
    );
    const blob = yield retry(RETRY_MAX_TRIES, RETRY_DELAY_LENGTH, () =>
      getResourceApi().getMedia(fileId, true),
    );

    saveAs(blob);

    yield put(exportPositionsSuccess({}));
  } catch (e) {
    yield put(exportPositionsFail(e.message));
  }
}

function* watchForRequestData() {
  yield takeLatest('positionSearch/searchPositions', searchPositions);
}

function* watchForExportPositions() {
  yield takeLatest('positionSearch/exportPositions', exportPositions);
}

export default [watchForRequestData(), watchForExportPositions()];
